import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getRewardPremiumRO(params) {
	return client.get("binary/reward/premium", {
		params: params,
	});
}

function getHistoryRewardPremiumRO(params) {
	return client.get("binary/reward/premium/approved", {
		params: params,
	});
}

function getRewardRO(params) {
	return client.get("binary/reward/ro", {
		params: params,
	});
}

function getHistoryRewardRO(params) {
	return client.get("binary/reward/ro/qualified", {
		params: params,
	});
}

function getRewardKhasanah(params) {
	return client.get("binary/reward/khasanah", {
		params: params,
	});
}

function getHistoryRewardKhasanah(params) {
	return client.get("binary/reward/khasanah/history", {
		params: params,
	});
}

function claimRewardKhasanah(params) {
	return client.post("binary/reward/khasanah/claim", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getRewardEkonomi(params) {
	return client.get("binary/reward/ekonomi", {
		params: params,
	});
}

function getHistoryRewardEkonomi(params) {
	return client.get("binary/reward/ekonomi/history", {
		params: params,
	});
}

function claimRewardEkonomi(params) {
	return client.post("binary/reward/ekonomi/claim", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getRewardTitik(params) {
	return client.get("binary/reward/list", {
		params: params,
	});
}

function getHistoryRewardTitik(params) {
	return client.get("binary/reward/history", {
		params: params,
	});
}

function getRewardPribadi(params) {
	return client.get("binary/reward-personal/list", {
		params: params,
	});
}

function getHistoryRewardPribadi(params) {
	return client.get("binary/reward-personal/history", {
		params: params,
	});
}

function getRewardGroup(params) {
	return client.get("binary/reward-group/list", {
		params: params,
	});
}

function getHistoryRewardGroup(params) {
	return client.get("binary/reward-group/history", {
		params: params,
	});
}

function getHistoryRewardPoint(params) {
	return client.get("binary/reward/premium/point", {
		params: params,
	});
}

function getHistoryRewardROPoint(params) {
	return client.get("binary/reward/ro/point", {
		params: params,
	});
}


export default {
	getRewardPremiumRO,
	getRewardTitik,
	getRewardPribadi,
	getRewardGroup,
	getRewardKhasanah,
	getRewardEkonomi,
	getHistoryRewardPremiumRO,
	getHistoryRewardTitik,
	getHistoryRewardPribadi,
	getHistoryRewardGroup,
	getHistoryRewardPoint,
	getHistoryRewardKhasanah,
	claimRewardKhasanah,
	getHistoryRewardEkonomi,
	claimRewardEkonomi,

	getRewardRO,
	getHistoryRewardRO,
	getHistoryRewardROPoint
};